'use strict';

angular.module('shiftTraderApp')
  .controller('ManageTradesCtrl', function ($scope, trades, $uibModal, $timeout, me, Session, ShiftTradesResource, TimeService,
                                            AvailabilityRules, SAErrorHandler, allDepartments, $state,
                                            UserPermissionsService, toastr, GlobalRxFeed) {
    $scope.trades = _.invoke(trades, '$initialize');
    $scope.me = me;
      
    var allDeptPositionIds = _.flatten(_.map(allDepartments, function(dept) {
      return _.pluck(dept.positions, 'id');
    }));

    if (_.findIndex(allDepartments, {id: null}) < 0) {
      allDepartments.push({
        id: null,
        name: 'Uncategorized'
      });
    }

    $scope.allDepartments = _.map(allDepartments, function(dept) {
      dept._selected = true;
      return dept;
    });

    $scope.state = {
      showSelector: 'true',
      selectedDepartments: _.cloneDeep($scope.allDepartments),
      tradesBackTill: TimeService.getNowInStoreTime().startOf('day').subtract(3, 'month'),
      isLoadingMoreTrades: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    function processRawPermissions() {
      $scope.state.derivedPermissions = {
        canApproveTrade: $scope.state.rawPermissions['trades.approve']
      };
    }

    UserPermissionsService.getCanDict(['trades.approve'], 'current')
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });


    $scope.toggleDepartmentSelection = function(idx) {
      $scope.allDepartments[idx]._selected = !$scope.allDepartments[idx]._selected;
      if (!$scope.allDepartments[idx]._selected) {
        var idy = _.findIndex($scope.state.selectedDepartments, {id: $scope.allDepartments[idx].id});
        $scope.state.selectedDepartments.splice(idy, 1);
      } else {
        $scope.state.selectedDepartments.push($scope.allDepartments[idx]);
      }
      calculateFilteredArrays();
    };

    var calculateFilteredArrays = function() {
      // will do this for trades and days off seperately

      // trades first
      $scope.activeTrades = _.filter($scope.trades, function(trade) {
        return trade.$calculateActive(true);
      });


      $scope.inactiveTrades = _.filter($scope.trades, function(trade) {
        return !trade.$calculateActive(true);
      });

      $scope.currentTradesList = $scope.state.showSelector === 'true' ? $scope.activeTrades : $scope.inactiveTrades;

      var positionIdsToShow = _.flatten(_.map($scope.state.selectedDepartments, function(dept) {
        return _.pluck(dept.positions, 'id');
      }));
      $scope.currentFilteredTradesList = _.where($scope.currentTradesList, function(trade) {
        var positionIdsToTest = [trade.work_period.position_id];
        if (!trade.$isGiveaway()) {
          positionIdsToTest.push(trade.trade_work_period.position_id);
          positionIdsToTest = _.uniq(positionIdsToTest);
        }

        //2nd half of this OR makes it where position's that aren't in a department (whether ACTIVE =true or ACTIVE=false show up in the list)

        return _.any(positionIdsToTest, function(testPosId) {
          return _.contains(positionIdsToShow, testPosId);
        }) || _.any(positionIdsToTest, function(testPosId) {
            return !_.contains(allDeptPositionIds, testPosId);
          });
      });
    };

    calculateFilteredArrays();

    var data = {
      active: false,
      start_time: $scope.state.tradesBackTill.format()
    };

    ShiftTradesResource.query(data, function(data) {
      _.forEach(data, function(trade) {
        trade.created_at_tz = moment.utc(trade.created_at).tz(Session.getTimezone());
        trade.timeAgo = trade.created_at_tz.twix($scope.nowDate);
      });
      $scope.trades.push.apply($scope.trades, _.invoke(data, '$initialize'));
      calculateFilteredArrays();
    });

    $scope.getNextArchivedTradeInterval = function() {
      $scope.state.isLoadingMoreTrades = true;
      var lastTradesBackTill = moment($scope.state.tradesBackTill).subtract(1, 'day');
      $scope.state.tradesBackTill = $scope.state.tradesBackTill.subtract(1, 'month');

      var data = {
        active: false,
        start_time: $scope.state.tradesBackTill.format(),
        end_time: lastTradesBackTill.format()
      };

      ShiftTradesResource.query(data, function(data) {
        _.forEach(data, function(trade) {
          trade.created_at_tz = moment.utc(trade.created_at).tz(Session.getTimezone());
          trade.timeAgo = trade.created_at_tz.twix($scope.nowDate);
        });
        $scope.trades.push.apply($scope.trades, _.invoke(data, '$initialize'));
        $scope.trades = _.uniq($scope.trades, function(trade) {
          return trade.id;
        });
        calculateFilteredArrays();
        $scope.state.isLoadingMoreTrades = false;
      });
    };

    $scope.nowDate = moment().tz(Session.getTimezone());

    _.forEach($scope.trades, function(trade) {
      trade.created_at_tz = moment.utc(trade.created_at).tz(Session.getTimezone());
      trade.timeAgo = trade.created_at_tz.twix($scope.nowDate);
    });

    // Copy of saShiftTradeLineItem method with VERY minor edits
    // TODO: change the view to make this work!
    $scope.prompt = function(trade, mode) {
      var options = {
        templateUrl: 'views/promptTrade.html',
        size: 'md',
        controller: 'promptTradeDialogCtrl',
        resolve: {
          trade: function() {
            return trade;
          },
          myWorkPeriods: ['WorkPeriods', function (WorkPeriods) {
            if (mode === 'accept' || mode === 'decline' && $scope.trade.$isGiveaway()) {
              var data = {
                user_id: $scope.me.id,
                start_time: moment(trade.work_period.start_time).subtract(24, 'hours').toISOString(),
                end_time: moment(trade.work_period.end_time).add(24, 'hours').toISOString()
              };
              return WorkPeriods.getAll(data);
            } else {
              return [];
            }
          }],
          mode: function() {
            var a = {};
            a.mode = mode;
            return a;
          },
          me: function() {
            return $scope.me;
          }
        }
      };
      options.resolve.mode[mode] = true;

      var modalInstance = $uibModal.open(options);
      modalInstance.result.then(function (result) {
        if (angular.isDefined(result)) {
          var ind = _.findIndex($scope.trades, function(trade) {
            return result.shift_trade.id === trade.id;
          });
          $scope.trades[ind].shift_trade_responses.push(result);
        }
      }, function(reason) {
        console.log('promptTrade dialog dismissed for reason ' + reason);
      });
    };

    $scope.setShow = function(val) {
      $scope.state.showSelector = val;

      calculateFilteredArrays();
    };

    $timeout(function () {
      GlobalRxFeed.push('page-rendered', 'manageTrades')
    })
  });
